export default __webpack_public_path__ + "static/media/Carel 1.6ce22fb5.png";